const _excluded = ["title", "content", "className", "skin", "cancelButtonDisabled", "primaryButtonDisabled", "primaryButtonLabel", "primaryButtonTestid", "primaryButtonTooltip", "primaryButtonLoading", "primaryButtonIntent", "secondaryButtonLabel", "secondaryButtonTestid", "secondaryButtonLoading", "width", "textAlignCenter", "as", "onPrimaryButtonClick", "onSecondaryButtonClick", "onCloseButtonClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { CloseButton } from "../CloseButton";
import { Typography } from "../Typography";
import { Button } from "../Button";
import styles from "./ConfirmationModal.module.scss";
export function ConfirmationModal(props) {
  const {
    title,
    content,
    className,
    skin = 'primary',
    cancelButtonDisabled,
    primaryButtonDisabled,
    primaryButtonLabel,
    primaryButtonTestid,
    primaryButtonTooltip,
    primaryButtonLoading,
    primaryButtonIntent,
    secondaryButtonLabel,
    secondaryButtonTestid,
    secondaryButtonLoading,
    width = 590,
    textAlignCenter = true,
    as = 'div',
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    onCloseButtonClick
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const Tag = as;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn(styles.root, className)
  }, rest, {
    style: {
      width
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.header, styles["".concat(skin, "Skin")])
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    variant: "h6",
    "data-testid": "confirmation-modal-title"
  }, title), /*#__PURE__*/React.createElement(CloseButton, {
    skin: "transparent",
    onClick: onCloseButtonClick || onSecondaryButtonClick,
    className: styles.closeButton,
    "data-testid": "confirmation-modal-close-btn",
    disabled: !!cancelButtonDisabled
  })), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.body)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.content, {
      [styles.contentAlignmentCenter]: textAlignCenter
    })
  }, typeof content === 'string' ? /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1"
  }, content) : content)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, secondaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    skin: "".concat(skin, "Outline"),
    onClick: onSecondaryButtonClick,
    "data-testid": secondaryButtonTestid !== null && secondaryButtonTestid !== void 0 ? secondaryButtonTestid : 'confirmation-modal-secondary-btn',
    loading: secondaryButtonLoading,
    type: "button"
  }, secondaryButtonLabel), primaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    skin: "".concat(skin),
    intent: primaryButtonIntent,
    onClick: onPrimaryButtonClick,
    "data-testid": primaryButtonTestid !== null && primaryButtonTestid !== void 0 ? primaryButtonTestid : 'confirmation-modal-primary-btn',
    loading: primaryButtonLoading,
    disabled: primaryButtonDisabled,
    tooltip: primaryButtonTooltip ? {
      placement: 'top',
      title: primaryButtonTooltip
    } : undefined
  }, primaryButtonLabel))));
}